import CategorySelect from "./components/categorySelect";

(function () {

    const sampleResults = function (){
         return `<a href="#" class="articlePreview">
        <div class="articlePreview__imageWrapper">
            <img class="articlePreview__image" src="/wp-content/themes/nswm/assets/test/article-thumbnail.jpg" alt="">
        </div>
        <div class="articlePreview__categories">
    
                        <span onclick="swmGoTo(event, #)" class="articlePreview__categoryLink">blog</span>
    
                        <span onclick="swmGoTo(event, #)" class="articlePreview__categoryLink">boliwia</span>
    
                        <span onclick="swmGoTo(event, #)" class="articlePreview__categoryLink">misje</span>
    
                </div>
        <h3 class="articlePreview__title">category.js category.js w&nbsp;kwarantannie, czyli Święte Triduum Paschalne</h3>
        <div class="articlePreview__date">
            22 kwietnia 2020
        </div>
    </a>`;
    } 

    const resultsContainer = document.getElementById("categoryResults");
    const placeholder = document.getElementById("categoryPlaceholder");
    const categoriesBar = document.getElementById("categoryCategoriesSelectDesktop");
    const categoriesMobileBar = document.getElementById("categoryCategoriesSelectMobile");
   
    const handleCategorySelectFn = function (categoryName, pageNumber) {
  console.log(categoryName, pageNumber);
        const resultsFragment = document.createElement("template");
        resultsFragment.innerHTML = getReponse();//sampleResults;
        resultsContainer.appendChild(resultsFragment.content);
        return true;
    }

    const categorySelect = new CategorySelect({
        resultsContainer: resultsContainer,
        categoriesBar: categoriesBar,
        categoriesMobileBar: categoriesMobileBar,
        placeholder: placeholder,
        handleCategorySelectFn: handleCategorySelectFn
    });

})();